// extracted by mini-css-extract-plugin
export default {"value":"kpiCard_value__mcQ7P","count":"kpiCard_count__v1XeD","label":"kpiCard_label__GYRvc","trend":"kpiCard_trend__kEa79","alert":"kpiCard_alert__yZXrO"};